import { InvalidUrlError } from '@execonline-inc/url';
import { HttpError } from 'ajaxian';
import { AppyError } from '../../../../Appy';
import { FilterOptionsResource } from '../OrganizationFilter/OrganizationFilterTypeahead/UseOrganizationFilterTypeahead/Types';

interface Loading {
  kind: 'loading';
}

interface Ready {
  kind: 'ready';
  resource: FilterOptionsResource;
}

interface Error {
  kind: 'error';
}

export type State = Loading | Ready | Error;

export type FilterError = HttpError | InvalidUrlError | AppyError;

export const loading: Loading = { kind: 'loading' };

export const error: Error = { kind: 'error' };

export const ready = (resource: FilterOptionsResource): Ready => ({
  kind: 'ready',
  resource: resource,
});
